import React, { useEffect, useState } from "react";
import { ResponsiveLine } from "@nivo/line";
import { fetchPieces } from "../services/api";
import Spinner from "./Spinner";

const SubmittedPiecesByDOBChart = ({ startDate, promptId }) => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchAndPrepareData = async () => {
      setIsLoading(true);
      try {
        const rawData = await fetchPieces(startDate, promptId);

        // Filter submitted entries
        const submitted = rawData.filter(entry => entry.submitted === true);
        // Group by full date (YYYY-MM-DD)
        const countsByDay = submitted.reduce((acc, entry) => {
          // Extract date directly from string to avoid timezone conversion issues
          const date = entry.created_at.split(" ")[0]; // Get "2025-09-07" from "2025-09-07 04:56:11.026441"
          acc[date] = (acc[date] || 0) + 1;
          return acc;
        }, {});

        // Format for Nivo line chart
        const formatted = Object.entries(countsByDay)
          .map(([date, count]) => ({ 
            x: `${date}T12:00:00`, // Add time component to avoid timezone shift
            y: count 
          }))
          .sort((a, b) => new Date(a.x) - new Date(b.x));

        setData([
          {
            id: "# of Submitted Pieces",
            color: "#4285F4",
            data: formatted
          }
        ]);
      } catch (error) {
        console.error("Failed to load line chart data", error);
      } finally {
        setIsLoading(false);
      }
    };

    // reset for immediate spinner on change
    setData([]);
    fetchAndPrepareData();
  }, [startDate, promptId]);

  return (
    <div style={{ height: "400px", width: "100%" }}>
      {isLoading ? (
        <Spinner label="Loading chart…" />
      ) : (
        <ResponsiveLine
        data={data}
        margin={{ top: 50, right: 30, bottom: 80, left: 60 }}
        xScale={{ type: "time", format: "%Y-%m-%dT%H:%M:%S", precision: "day" }}
        xFormat="time:%b %d, %Y"
        yScale={{ type: "linear", min: 0 }}
        
        axisBottom={{
          format: "%b %d, %Y",
          tickValues: "every 3 days",
          legend: "Created At",
          legendOffset: 50,
          legendPosition: "middle",
          tickRotation: -45
        }}
        axisLeft={{
          legend: "# of Submitted Pieces",
          legendOffset: -50,
          legendPosition: "middle"
        }}
        colors={() => "#4285F4"}
        pointSize={4}
        useMesh={true}
        enableArea={false}
        enablePoints={true}
      />
      )}
    </div>
  );
};

export default SubmittedPiecesByDOBChart;
